"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cToF = cToF;
exports.convertCToF = convertCToF;
exports.mmToin = mmToin;
exports.convertmmToin = convertmmToin;
function cToF(value) {
    return Math.floor((value * 9) / 5 + 32);
}
function convertCToF(values) {
    if (values === undefined) {
        return values;
    }
    return Array.isArray(values) ? values.map(cToF) : cToF(values);
}
function mmToin(value) {
    return parseFloat((value / 25.4).toFixed(1));
}
function convertmmToin(values) {
    if (values === undefined) {
        return values;
    }
    return Array.isArray(values) ? values.map(mmToin) : mmToin(values);
}
